import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { PublicOfferPageContent } from 'client/contents/PublicOfferPageContent/PublicOfferPageContent'

type TProps = {}

const PublicOfferPage: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.PublicOfferPage)
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead title={t('title')} />
      <PublicOfferPageContent />
    </article>
  )
}

export default PublicOfferPage
